<template>
    <v-form ref="CandidatureDecommissionner" id="CandidatureDecommissionner" lazy-validation>
        <div v-if="$storeCandidature.configurationClient.ParamFormulaire.Redirection">
            <!-- Affichage du compteur de 3 secondes -->
            <div class="font-weight-medium center headline mx-3 orange">
                <span v-if="$storeCandidature.langueFormulaire === 'en'">
                    This form is currently unavailable
                </span>
                <span v-else>
                    Ce formulaire est actuellement indisponible
                </span>
                <br />
                <span v-if="$storeCandidature.langueFormulaire === 'en'">
                    You will be redirected in {{ seconds }} seconds, please wait. 
                    [<a :href="$storeCandidature.configurationClient.ParamFormulaire.Redirection"> CClick here </a>] in case of difficulty
                </span>
                <span v-else>
                    Vous serez redirigé(e) dans {{ seconds }} secondes, merci de patienter. 
                    [<a :href="$storeCandidature.configurationClient.ParamFormulaire.Redirection"> Cliquez ici </a>] en cas difficulté
                </span>
            </div>
        </div>
        <div v-else>
            <!-- Affichage du message d'erreur -->
            <div class="font-weight-medium center headline mx-3 orange">
                <span v-if="$storeCandidature.langueFormulaire === 'en'">
                   404 This form is disabled
                </span>
                <span v-else>
                   404 Ce formulaire est désactivé
                </span>
            </div>
        </div>
    </v-form>
</template>

<script>
    export default {
        data() {
            return {
                countdown: 3, // 3 secondes
                seconds: 3
            };
        },
        methods: {
            redirectAfterDelay() {
                setTimeout(() => { 
                    // Redirection vers l'URL spécifiée dans $storeCandidature.configurationClient.ParamFormulaire.Redirection
                    window.location.href = this.$storeCandidature.configurationClient.ParamFormulaire.Redirection;
                }, this.countdown * 1000); // Redirection après le délai défini
            },
            startTimer() {
                const timer = setInterval(() => {
                    if (this.countdown <= -1) {
                        clearInterval(timer);
                        // Exécuter une action à la fin du compte à rebours (si nécessaire)
                    } else {
                        this.seconds = this.countdown;
                        this.countdown--;
                    }
                }, 1000); // Mettre à jour le décompte chaque seconde
            }
        },
        mounted() {
            if (this.$storeCandidature.configurationClient.ParamFormulaire.Redirection) {
                this.startTimer(); // Démarrer le décompte si une redirection est spécifiée
                this.redirectAfterDelay(); // Rediriger après le délai
            }
        }
    };
</script>
